import { javascript } from "@codemirror/lang-javascript";
import { BASE_TASK, CREATE_COMMENT } from "../../../../Config/ApiUrl";

import { CommandCreateComment } from "../apps/tasks/commands";

export const RelationshipMixins = {
  methods: {
    async updateAssignee(task, assigneeId, new_assignees) {
      const data = {
        data: (new_assignees ?? task.assignees)
          .filter(({ id }) => id !== assigneeId)
          .map(({ id }) => {
            return {
              type: "assignees",
              id,
            };
          }),
      };

      task.slaves.forEach((slave) => {
        this.$store.dispatch("change_kanban_column_task_relationship", {
          callback: (_) => {},
          data,
          taskId: slave.id,
          type: "assignees",
        });
      });

      return await this.$store.dispatch(
        "change_kanban_column_task_relationship",
        {
          callback: (returned_data) => {
            const new_value = JSON.parse(
              JSON.stringify(
                returned_data.map(({ attributes, id }) => {
                  return {
                    id,
                    title: `${attributes.first_name} ${attributes.last_name}`,
                    alt: `${attributes.first_name} ${attributes.last_name}`,
                    subTitle: attributes.email,
                    background: attributes.color,
                  };
                })
              )
            );

            if (typeof task.updateTask === "function")
              task.updateTask("assignees", new_value);
            else {
              if (task.task_system_id)
                this.$emit("update-subtask", {
                  new_value,
                  property: "assignees",
                });
              else
                this.$store.commit("CHANGE_KANBAN_COLUMN_TASK_PROPERTY", {
                  taskId: task.id,
                  step_index: task.column.index,
                  new_value,
                  property: "assignees",
                });
            }
          },
          data,
          taskId: task.id,
          type: "assignees",
        }
      );
    },
    async updateTag(task, tagId) {
      // this.crudAction = true;

      const data = {
        data: task.tags
          .filter(({ id }) => id !== tagId)
          .map(({ id }) => {
            return {
              type: "tags",
              id,
            };
          }),
      };

      task.slaves.forEach((slave) => {
        this.$store.dispatch("change_kanban_column_task_relationship", {
          callback: (_) => {},
          data,
          taskId: slave.id,
          type: "tags",
        });
      });

      return await this.$store.dispatch(
        "change_kanban_column_task_relationship",
        {
          callback: (returned_data) => {
            // this.crudAction = false;

            if (task.task_system_id) {
              this.$emit("update-subtask", {
                new_value: JSON.parse(JSON.stringify(returned_data)).map(
                  (p) => ({
                    id: p.id,
                    label: p.attributes.label,
                    variant: p.attributes.variant,
                  })
                ),
                property: "tags",
                update_parent: false,
                update_callback: null,
              });
            } else {
              this.$store.commit("CHANGE_KANBAN_COLUMN_TASK_PROPERTY", {
                taskId: task.id,
                step_index: task.column.index,
                new_value: JSON.parse(JSON.stringify(returned_data)).map(
                  (p) => ({
                    id: p.id,
                    label: p.attributes.label,
                    variant: p.attributes.variant,
                  })
                ),
                property: "tags",
              });
            }
          },
          data,
          taskId: task.id,
          type: "tags",
        }
      );
    },
    async updateFileTask(file, taskToDeleteId, taskObject = null) {
      let addId = [];

      if (taskToDeleteId && taskObject) {
        addId = taskObject.slaves
          .filter((obj1) => file.tasks.some((obj2) => obj2.id === obj1.id))
          .map((x) => x.id);
      }

      const data = {
        relationships: {
          tasks: {
            data: file.tasks
              .filter(({ id }) => id !== taskToDeleteId)
              .filter(({ id }) => !addId.includes(id))
              .map(({ id }) => {
                return {
                  type: "tasks",
                  id,
                };
              }),
          },
        },
      };

      return await this.axiosPatch({
        url: `${BASE_TASK}/files/${file.id}`,
        data,
      });
    },
  },
};

export const CommentsMixins = {
  data() {
    return {
      new_comment: {
        text: "",
        internal: false,
      },
      comment_input: false,
      commenting: false,
      deleteConfirmationModalActive: false,
      comment_to_delete: undefined,
    };
  },
  methods: {
    loadReplies() {
      this.subComments_loading = true;
      this.viewReplies = true;
      this.axiosGet(`${CREATE_COMMENT}/${this.comment.id}/replies`)
        .then(({ data }) => {
          const comments = data.data.map((cm) => {
            const make = new CommandCreateComment(cm, [this.client]);
            return make.execute();
          });
          this.subComments = comments;
          // const that = this;
          // setTimeout(() => {
          //   $(`.comments .file-mention`).on("click", function () {
          //     that.$store.dispatch("openNewTab", {
          //       fileId: parseInt($(this).attr("data-id")),
          //     });
          //   });
          // }, 2000);
        })
        .catch((err) => {
          console.log(err);
          this.viewReplies = false;
        })
        .finally((_) => {
          this.subComments_loading = false;
        });
    },
    createFromReply(comment) {
      this.comment.push(comment);
    },
    createComment(reply = false) {
      this.commenting = true;
      const { text, internal } = this.new_comment;
      let has_mention = [];
      try {
        has_mention = $(this.new_comment.text)
          .find(".mention")
          .map(function () {
            return $(this).data("id");
          })
          .toArray();
      } catch (error) {
        console.log(error);
      }
      const data = {
        data: {
          type: "comments",
          attributes: {
            content: text,
            internal: internal,
            mentions: JSON.stringify(has_mention),
          },
        },
      };

      let promise = null;
      if (this.new_comment.id) {
        promise = this.axiosPatch({
          url: `${CREATE_COMMENT}/${this.new_comment.id}`,
          data,
        });
      } else {
        data.data.attributes.task_user_id = this.user.id;
        data.data.attributes.task_id = reply
          ? this.comment.taskID
          : this.task.id;
        if (reply) {
          data.data.attributes.reply = this.comment.reply
            ? this.comment.reply
            : this.comment.id;
        }
        promise = this.axiosPost({
          url: CREATE_COMMENT,
          data,
        });
      }

      promise
        .then((res) => {
          // this.kanbanViewData = res.data.data

          const make = new CommandCreateComment(res.data.data, [this.client]);
          const comment = make.execute();
          let msg = "";
          if (this.new_comment.id) {
            msg = "Comment updated successfully";
            this.comments = this.comments.map((cm) => {
              if (cm.id == comment.id) cm = comment;
              return cm;
            });
          } else {
            msg = "Comment Created successfully";
            if (reply && !this.comment.reply) {
              this.subComments = [comment, ...this.subComments];
            } else {
              if (this.comments) {
                this.comments = [comment, ...this.comments];

                if (typeof this.task.updateTask === "function")
                  this.task.updateTask(
                    "comments_number",
                    this.task.comments_number + 1
                  );
              } else {
                this.$emit("redirect", comment);
              }
            }
          }
          const that = this;
          setTimeout(() => {
            $(`.comments .file-mention`).off();
            $(`.comments .file-mention`).on("click", function () {
              that.$store.dispatch("openNewTab", {
                fileId: parseInt($(this).attr("data-id")),
              });
            });
          }, 2000);

          this.clearComment(true);
          this.new_comment = {
            ...this.new_comment,
            text: "",
            id: undefined,
          };
          this.$toastr.s(msg);
        })
        .catch((e) => {
          console.log(e);
          if (this.new_comment.id)
            this.$toastr.e(
              "You do not have the authorization to perform this action"
            );
          else this.$toastr.e("Something went wrong!");
        })
        .finally((_) => (this.commenting = false));
    },
  },
};

export const FIlesMixins = {
  computed: {
    fileUrl() {
      return `${window.settings.aws_url}/${this.file?.url}`;
    },
  },

  methods: {
    fileUrlspecial(url) {
      return `${window.settings.aws_url}/${this.file?.url ?? url}`;
    },

    mime(mime) {
      const [one, two] = mime.split("/");
      switch (one) {
        case "image":
          return "bi-file-image";
        case "video":
          return "bi-file-play";
        case "text":
          return two === "javascript" ? "bi-filetype-js" : "bi-file-text";
        case "audio":
          return "bi-file-music";
        case "application":
          switch (two) {
            case "pdf":
              return "bi-file-pdf-fill";
            case "x-javascript":
              return "bi-filetype-js";
            case "msword":
              return "bi-file-earmark-word";
            default:
              if (["zip", "x-compressed", "x-gzip"].includes(two))
                return "bi-file-earmark-zip";
              else return "bi-file-earmark";
          }

        default:
          return "bi-file-earmark";
      }
    },
  },
  filters: {
    getReadableFileSizeString: (fileSizeInBytes) => {
      let i = -1;
      const byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);

      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    },
    parseCreatedAt: (date) => {
      return moment(date).format("YYYY-MM-DD");
    },

    timestamp: (date) => {
      const file_date = new Date(date).getTime();
      const now = new Date().getTime();
      const timeDiff = now - file_date;

      const seconds = Math.floor(timeDiff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      // Determine the appropriate message based on the elapsed time
      let message = "";
      if (days > 0) {
        message = `${days} day${days === 1 ? "" : "s"} ago`;
      } else if (hours > 0) {
        message = `${hours} hour${hours === 1 ? "" : "s"} ago`;
      } else if (minutes > 0) {
        message = `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
      } else {
        message = "A few seconds ago";
      }
      return message;
    },
  },
};

export const ColorsMixins = {
  methods: {
    getRandomColor() {
      // Generate random red, green, and blue values between 0 and 255
      const red = Math.floor(Math.random() * 256);
      const green = Math.floor(Math.random() * 256);
      const blue = Math.floor(Math.random() * 256);

      // Calculate the luminance of the color using the formula for relative luminance
      const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;

      // If the luminance is too low (i.e. the color is too dark), generate a new color
      if (luminance < 0.5) {
        return ColorsMixins.methods.getRandomColor();
      }

      // Otherwise, return the color as a string in hexadecimal format
      return `#${ColorsMixins.methods.padZero(
        red.toString(16)
      )}${ColorsMixins.methods.padZero(
        green.toString(16)
      )}${ColorsMixins.methods.padZero(blue.toString(16))}`;
    },
    padZero(str) {
      return str.length === 1 ? `0${str}` : str;
    },
  },
};

export const cronExpressionMixins = {
  methods: {
    cronExpressionToObject(cron) {
      const [minute, hour, dayOfMonth, month, dayOfWeek] = cron.split(" ");
      return {
        time: [hour, minute].join(":"),
        day:
          dayOfMonth === "*"
            ? dayOfWeek === "*"
              ? null
              : this.reverseCronFormatNumbers(dayOfWeek)
            : this.reverseCronFormatNumbers(dayOfMonth),
        frequency:
          dayOfMonth === "*"
            ? dayOfWeek === "*"
              ? "daily"
              : "weekly"
            : "monthly",
      };
    },
    formatCronExpression(input, callback = () => {}) {
      if (input.frequency) {
        if (input.time) {
          const [h, m] = input.time.split(":");
          let finalCron = [m, h, "*", "*", "*"];
          if (input.frequency === "weekly")
            finalCron[4] = this.formatCronNumbers(input.day);
          if (input.frequency === "monthly")
            finalCron[2] = this.formatCronNumbers(input.day);
          return finalCron.join(" ");
        } else {
          callback();
          throw new Error("return");
        }
      }
      return null;
    },
    reverseCronFormatNumbers(formattedString) {
      const groups = formattedString.split(",");
      const numbers = [];

      for (let group of groups) {
        if (group.includes("-")) {
          const range = group.split("-");
          const start = parseInt(range[0]);
          const end = parseInt(range[1]);
          for (let num = start; num <= end; num++) {
            numbers.push(num);
          }
        } else {
          numbers.push(parseInt(group));
        }
      }

      return numbers;
    },
    // Helper function to get month name from month number
    formatCronNumbers(numbers) {
      let formatted = [];
      let start = numbers[0];
      let end = numbers[0];

      for (let i = 1; i < numbers.length; i++) {
        if (numbers[i] === end + 1) {
          end = numbers[i];
        } else {
          if (start === end) {
            formatted.push(start.toString());
          } else {
            formatted.push(start + "-" + end);
          }
          start = numbers[i];
          end = numbers[i];
        }
      }

      if (start === end) {
        formatted.push(start.toString());
      } else {
        formatted.push(start + "-" + end);
      }

      return formatted.join(",");
    },
  },
};

export const SharedMixins = {
  data() {
    return {
      weekDays: [
        { id: 1, value: "Monday" },
        { id: 2, value: "Tuesday" },
        { id: 3, value: "Wednesday" },
        { id: 4, value: "Thursday" },
        { id: 5, value: "Friday" },
        { id: 6, value: "Saturday" },
        { id: 7, value: "Sunday" },
      ],
      monthDays: [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
        { id: 3, value: 3 },
        { id: 4, value: 4 },
        { id: 5, value: 5 },
        { id: 6, value: 6 },
        { id: 7, value: 7 },
        { id: 8, value: 8 },
        { id: 9, value: 9 },
        { id: 10, value: 10 },
        { id: 11, value: 11 },
        { id: 12, value: 12 },
        { id: 13, value: 13 },
        { id: 14, value: 14 },
        { id: 15, value: 15 },
        { id: 16, value: 16 },
        { id: 17, value: 17 },
        { id: 18, value: 18 },
        { id: 19, value: 19 },
        { id: 20, value: 20 },
        { id: 21, value: 21 },
        { id: 22, value: 22 },
        { id: 23, value: 23 },
        { id: 24, value: 24 },
        { id: 25, value: 25 },
        { id: 26, value: 26 },
        { id: 27, value: 27 },
        { id: 28, value: 28 },
        { id: 29, value: 29 },
        { id: 30, value: 30 },
        { id: 31, value: 31 },
      ],
      frequency: [
        { value: "weekly", id: "weekly" },
        { value: "monthly", id: "monthly" },
        { value: "daily", id: "daily" },
      ],
    };
  },

  methods: {
    cronToReadable(cronExpression) {
      const [minute, hour, dayOfMonth, month, dayOfWeek] =
        cronExpression.split(" ");

      // Convert cron expression parts to readable strings
      const minuteStr = minute === "*" ? "every minute" : `at minute ${minute}`;
      const hourStr =
        hour === "*" ? "every hour" : `at ${hour.padStart(2, "0")}:`;
      const dayOfMonthStr =
        dayOfMonth === "*" ? "every day" : `on day ${dayOfMonth}`;
      const monthStr = month === "*" ? "every month" : `in ${month}`;
      const dayOfWeekStr =
        dayOfWeek === "*" ? "every day" : `on day ${dayOfWeek}`;

      // Return the concatenated human-readable string
      return `${minuteStr}, ${hourStr}00 ${dayOfMonthStr}, ${monthStr}, ${dayOfWeekStr}`;
    },
    getMonthName(month) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const monthIndex = parseInt(month) - 1;
      return monthNames[monthIndex];
    },

    // Helper function to get day of week name from day of week number
    getDayOfWeek(dayOfWeek) {
      const dayOfWeekNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const dayOfWeekIndex = parseInt(dayOfWeek);
      return dayOfWeekNames[dayOfWeekIndex];
    },
  },
};

export const SortedMixins = {
  methods: {
    sortNull(a, b, operator) {
      if (!a && !b) {
        return 0;
      }

      if (!a) {
        return 1;
      }

      if (!b) {
        return -1;
      }

      const started = new Date(a);
      const close = new Date(a);

      switch (operator) {
        case "<":
          return started < close ? -1 : 1;
        case ">":
          return started > close ? -1 : 1;
        case "==":
          return started == close ? 0 : -1;
        default:
          throw new Error("Invalid operator");
      }
    },

    sorting(type, tasks) {
      const sortByDate = (tasks, key, ascending = true) => {
        return tasks.sort((a, b) => {
          const dateA = a[key] ? new Date(a[key]) : null;
          const dateB = b[key] ? new Date(b[key]) : null;

          if (dateA === null && dateB !== null) return 1;
          if (dateA !== null && dateB === null) return -1;
          if (dateA === null && dateB === null) return 0;

          return ascending ? dateA - dateB : dateB - dateA;
        });
      };

      const sorted = {
        "dueDate asc": (tasks) => sortByDate(tasks, "due_date", true),
        "dueDate desc": (tasks) => sortByDate(tasks, "due_date", false),
        "startedAt asc": (tasks) => sortByDate(tasks, "started_at", true),
        "startedAt desc": (tasks) => sortByDate(tasks, "started_at", false),
      };

      return sorted[type](tasks);
    },
  },
};
